module.exports = __webpack_public_path__ + "static/media/FBG.13a901e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/shgn/footerLogos/mobile/FBG.svg
// module id = 99
// module chunks = 0